/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_What_Is_Json_S4_TitleInputs */

const en_guide_what_is_json_s4_title = /** @type {(inputs: Guide_What_Is_Json_S4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Common JSON Use Cases`)
};

const ko_guide_what_is_json_s4_title = /** @type {(inputs: Guide_What_Is_Json_S4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`일반적인 JSON 사용 사례`)
};

const ja_guide_what_is_json_s4_title = /** @type {(inputs: Guide_What_Is_Json_S4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSONの一般的なユースケース`)
};

/**
* | output |
* | --- |
* | "Common JSON Use Cases" |
*
* @param {Guide_What_Is_Json_S4_TitleInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_what_is_json_s4_title = /** @type {((inputs?: Guide_What_Is_Json_S4_TitleInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_What_Is_Json_S4_TitleInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_what_is_json_s4_title(inputs)
	if (locale === "ko") return ko_guide_what_is_json_s4_title(inputs)
	return ja_guide_what_is_json_s4_title(inputs)
});